import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import ThemeStyles from "./theme";

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <ThemeStyles />
      <App />
    </BrowserRouter>,
  );
}
